module.exports = __webpack_public_path__ + "my-account-icon.png?037bcb9661cc18560b3f37aaf4ef4f3d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my-account-icon.png
// module id = 121
// module chunks = 0